module.exports = __webpack_public_path__ + "static/img/fish19.ee42153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish19.png
// module id = /fVG
// module chunks = 0